/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/SystemListGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for System List Groups
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    SYSTEMLISTGROUP_LIST_CONTAINER_LOADED,
    SYSTEMLISTGROUP_LIST_CONTAINER_UNLOADED,
    SYSTEMLISTGROUP_LIST_TABLE_LOADED,
    SYSTEMLISTGROUP_LIST_TABLE_UNLOADED,
    SYSTEMLISTGROUP_LIST_CHANGE_COMPANY,
    SYSTEMLISTGROUP_SELECT_ROW,
    SYSTEMLISTGROUP_ADD,
    SYSTEMLISTGROUP_EDIT,
    SYSTEMLISTGROUP_DELETE,
    SYSTEMLISTGROUP_DELETE_DISABLE,
    SYSTEMLISTGROUP_OPEN_WARNING,
    SYSTEMLISTGROUP_CLOSE_WARNING,
    SYSTEMLISTGROUP_EDIT_CONTAINER_LOADED,
    SYSTEMLISTGROUP_EDIT_CONTAINER_UNLOADED,
    SYSTEMLISTGROUP_EDIT_FORM_LOADED,
    SYSTEMLISTGROUP_EDIT_FORM_UNLOADED,
    SYSTEMLISTGROUP_EDIT_DATA_LOAD,
    SYSTEMLISTGROUP_EDIT_CONTAINER_SUBMIT,
    SYSTEMLISTGROUP_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeSystemListGroups';

const defaultState = {
    refreshList: false,
    systemlistgroups: [],
    companies: [],
    danger: false,
    systemlistgroupid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SYSTEMLISTGROUP_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemlistgroups: action.payload[0] ? action.payload[0].records : [],
                companies: action.payload[1] ? action.payload[1].companies : []
            }
        case SYSTEMLISTGROUP_LIST_CHANGE_COMPANY:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemlistgroups: action.payload ? action.payload.records : []
            }
        case SYSTEMLISTGROUP_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case SYSTEMLISTGROUP_SELECT_ROW:
            return {
                ...state,
                systemlistgroupid: action.id
            }
        case SYSTEMLISTGROUP_ADD:
            return {
                ...state
            }
        case SYSTEMLISTGROUP_EDIT:
            return {
                ...state,
                systemlistgroupid: action.id
            }
        case SYSTEMLISTGROUP_DELETE:
            return {
                ...state,
                systemlistgroupid: null
            }
        case SYSTEMLISTGROUP_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case SYSTEMLISTGROUP_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case SYSTEMLISTGROUP_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case SYSTEMLISTGROUP_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                companies: action.payload[1] ? action.payload[1].companies : [],
                systemlistgroupid: action.payload[0] ? action.payload[0].systemlistgroupid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case SYSTEMLISTGROUP_EDIT_DATA_LOAD:
            return {
                ...state,
                systemlistgroupid: action.payload ? action.payload.systemlistgroupid : 0,
                companyid: action.payload ? action.payload.companyid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case SYSTEMLISTGROUP_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case SYSTEMLISTGROUP_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case SYSTEMLISTGROUP_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case SYSTEMLISTGROUP_LIST_CONTAINER_UNLOADED:
        case SYSTEMLISTGROUP_LIST_TABLE_UNLOADED:
        case SYSTEMLISTGROUP_EDIT_CONTAINER_UNLOADED:
        case SYSTEMLISTGROUP_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/SystemListGroups.js